
export const APISettings = {
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    apiKey: "8FTFyLUXu",
    token: ""
};

const ContentTypes = {
    json: "application/json"
};

function getHeaders({ contentType } = {}) {
    return {
        "x-api-key": APISettings.apiKey,
        "Authorization": `Bearer ${APISettings.token}`,
        "Content-Type": contentType || ContentTypes.json
    };
}


/**
 * 
 * @param {string} subpath 
 * @param {{ method: "GET" | "POST", headers: Object, body: Object, query: Object }} param1 
 * @returns {Promise<{ ok: boolean, status: number, data: Object }>}
 */
export async function request(subpath, { method = "GET", headers = {}, body, query, contentType = ContentTypes.json, parsing = "json" } = {}) {

    const pathSplit = subpath.split(/\s+/);
    if(pathSplit.length === 2) {
        method = pathSplit[0];
        subpath = pathSplit[1];
    }

    if(subpath.startsWith("/")) subpath = subpath.slice(1);

    const params = query ? `?${new URLSearchParams(removeUndefinedValues(query))}` : "";
    const path = APISettings.baseUrl + "/" + subpath + params;
    const _headers = { ...getHeaders({ contentType }), ...headers };

    const response = await fetch(path, {
        method, headers: _headers, ...(body ? { body: JSON.stringify(body) } : {})
    });

    let data = response;
    if(parsing === "blob") data = await response.blob();
    else data = await response.json();
    
    return { ok: response.ok, status: response.status, data };
}

function removeUndefinedValues(obj) {
    const filtered = {};
    for(const key in obj) {
        const value = obj[key];
        if(value !== undefined) filtered[key] = value;
    }

    return filtered;
}